import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCardsStack = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_13655_12837",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 24,
		height: 24,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "#D9D9D9"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_13655_12837)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M3.65408 18.9288L2.44807 10.2635C2.38407 9.85833 2.48282 9.49042 2.74432 9.15975C3.00582 8.82892 3.33916 8.63142 3.74433 8.56725L5.14433 18.7212C5.15716 18.8046 5.19724 18.8735 5.26457 18.928C5.33191 18.9823 5.40724 19.0032 5.49057 18.9905L14.5561 17.7788H18.9906C18.8956 18.0648 18.7362 18.3061 18.5126 18.5027C18.2889 18.6996 18.0187 18.8198 17.7021 18.8635L5.64232 20.4653C5.14999 20.5357 4.71474 20.4204 4.33657 20.1193C3.95841 19.8179 3.73091 19.4211 3.65408 18.9288ZM8.11557 15.648C7.61041 15.648 7.18282 15.473 6.83282 15.123C6.48282 14.773 6.30782 14.3454 6.30782 13.8403V5.30775C6.30782 4.80258 6.48282 4.375 6.83282 4.025C7.18282 3.675 7.61041 3.5 8.11557 3.5H19.6923C20.1975 3.5 20.6251 3.675 20.9751 4.025C21.3251 4.375 21.5001 4.80258 21.5001 5.30775V13.8403C21.5001 14.3454 21.3251 14.773 20.9751 15.123C20.6251 15.473 20.1975 15.648 19.6923 15.648H8.11557ZM8.11557 14.148H19.6923C19.7822 14.148 19.8559 14.1192 19.9136 14.0615C19.9712 14.0038 20.0001 13.9301 20.0001 13.8403V5.30775C20.0001 5.21792 19.9712 5.14417 19.9136 5.0865C19.8559 5.02883 19.7822 5 19.6923 5H8.11557C8.02574 5 7.95199 5.02883 7.89432 5.0865C7.83666 5.14417 7.80782 5.21792 7.80782 5.30775V13.8403C7.80782 13.9301 7.83666 14.0038 7.89432 14.0615C7.95199 14.1192 8.02574 14.148 8.11557 14.148ZM10.1538 8.75H17.6538V7.25H10.1538V8.75ZM10.1538 11.827H14.6538V10.327H10.1538V11.827Z",
			fill: "currentColor"
		})
	})]
});
export default SvgCardsStack;
